import numeral from 'numeral';

export function formatRent(value) {
  return numeral(Math.ceil(value)).format('0,0');
}
